(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.NBBWelcomePopup = api;
    var boot = function () {
      var popupRoot = root.document && root.document.getElementById('nbb-welcome-popup');
      if (popupRoot && root.NBBWelcomePopupCore && root.NBBWatchProfileCore) {
        api.create(popupRoot, { core: root.NBBWelcomePopupCore, profileCore: root.NBBWatchProfileCore });
      }
    };
    if (root.document && root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var activeInstance = null;
  var STAGES = ['scratch', 'email', 'reward', 'brand', 'model', 'size', 'usecase', 'material', 'done'];
  var PROFILE_STAGES = ['brand', 'model', 'size', 'usecase', 'material'];
  var BACK_STAGES = PROFILE_STAGES.concat(['done']);
  var STAGE_META = {
    scratch: { label: 'SCRATCH & CLAIM · 01', progress: '18%' },
    email: { label: 'WELCOME · 01', progress: '18%' },
    reward: { label: 'YOUR GIFT · 02', progress: '36%' },
    brand: { label: 'YOUR WATCH · 01 OF 05', progress: '40%' },
    model: { label: 'YOUR WATCH · 02 OF 05', progress: '54%' },
    size: { label: 'YOUR WATCH · 03 OF 05', progress: '68%' },
    usecase: { label: 'YOUR ROUTINE · 04 OF 05', progress: '82%' },
    material: { label: 'YOUR STYLE · 05 OF 05', progress: '94%' },
    done: { label: 'ALL SET', progress: '100%' }
  };
  var ONCE_ACTIONS = new Set([
    'eligible', 'teaser_viewed', 'popup_opened', 'email_attempted', 'signup_succeeded',
    'offer_revealed', 'coupon_copied', 'profile_started', 'profile_completed', 'dismissed',
    'interaction_started', 'scratch_started'
  ]);
  var ANALYTICS_EVENTS = {
    eligible: 'popup_eligible',
    teaser_viewed: 'popup_teaser_viewed',
    popup_opened: 'popup_opened',
    step_viewed: 'popup_step_viewed',
    interaction_started: 'popup_interaction_started',
    scratch_started: 'popup_scratch_started',
    email_attempted: 'popup_email_attempted',
    signup_succeeded: 'popup_signup_completed',
    offer_revealed: 'popup_offer_revealed',
    coupon_copied: 'popup_coupon_copied',
    profile_started: 'popup_profile_started',
    profile_step_saved: 'popup_profile_step_completed',
    profile_step_skipped: 'popup_profile_step_skipped',
    profile_completed: 'popup_profile_completed',
    dismissed: 'popup_dismissed',
    error: 'popup_error'
  };
  var PROFILE_STEP_NUMBERS = { brand: 1, model: 2, size: 3, usecase: 4, material: 5 };
  var PREMIUM_STAGE_NUMBERS = { email: 1, reward: 2, brand: 3, model: 4, size: 5, usecase: 6, material: 7, done: 8 };
  var SCRATCH_STAGE_NUMBERS = { scratch: 1, email_claim: 2, reward: 3, brand: 4, model: 5, size: 6, usecase: 7, material: 8, done: 9 };
  var FIXED_SURFACE_SESSION_KEY = 'nbb_fixed_popup_session_v1';
  var FIXED_SURFACE_SESSION_MS = 30 * 60 * 1000;

  function create(root, dependencies) {
    if (!root) throw new Error('NBB welcome popup root is required');
    if (activeInstance) activeInstance.destroy();

    dependencies = dependencies || {};
    var doc = root.ownerDocument;
    var win = doc.defaultView;
    var core = dependencies.core || win.NBBWelcomePopupCore;
    if (!core) throw new Error('NBBWelcomePopupCore is required');
    var profileCore = dependencies.profileCore || win.NBBWatchProfileCore;
    if (!profileCore) throw new Error('NBBWatchProfileCore is required');

    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var now = dependencies.now || Date.now;
    var random = dependencies.random || Math.random;
    var setTimer = dependencies.setTimeout || win.setTimeout.bind(win);
    var clearTimer = dependencies.clearTimeout || win.clearTimeout.bind(win);
    var clipboard = dependencies.clipboard || (win.navigator && win.navigator.clipboard);
    var analytics = dependencies.analytics || win.NBBAnalytics;
    var storage = dependencies.storage;
    if (!storage) { try { storage = win.localStorage; } catch (_error) { storage = null; } }
    var overlay = root.querySelector('[data-popup-overlay]');
    var dialog = root.querySelector('[role="dialog"]');
    var teaser = root.querySelector('[data-welcome-teaser]');
    var teaserDismiss = root.querySelector('[data-dismiss-welcome-teaser]');
    var emailForm = root.querySelector('[data-email-form]');
    var emailInput = root.querySelector('[name="email"]');
    var emailError = root.querySelector('[data-email-error]');
    var submitButton = emailForm && emailForm.querySelector('[type="submit"]');
    var experimentVersion = root.dataset.experimentVersion || 'commercial_popup_ab_v1';
    var keyPrefix = 'nbb_welcome_popup_' + experimentVersion.replace(/^commercial_popup_/, '');
    var keys = {
      variant: keyPrefix + '_variant',
      dismissed: keyPrefix + '_dismissed',
      modalDismissCount: keyPrefix + '_modal_dismiss_count',
      teaserDismissed: keyPrefix + '_teaser_dismissed',
      teaserDismissCount: keyPrefix + '_teaser_dismiss_count',
      completed: keyPrefix + '_completed'
    };
    var listeners = [];
    var timers = [];
    var emitted = new Set();
    var viewedStages = new Set();
    var previousFocus = null;
    var turnstileWidgetId = null;
    var scratchInstance = null;
    var pendingProfileSave = null;
    var profileBusyButtons = [];
    var coverageStages = new Set();
    var delayReady = false;
    var engaged = false;
    var autoAllowed = false;
    var autoTimer = null;
    var productTeaserHost = null;
    var teaserObserver = null;
    var productExperiment = dependencies.productExperiment || (root.dataset.productExperiment === 'product_placement_v1' && win.NBBWelcomeProductExperiment && win.NBBWelcomeProductExperiment.create(win, {
      endpoint: root.dataset.signupEndpoint.replace(/\/v1\/welcome-signup$/, '/v1/product-experiment')
    }));
    var placementPending = false;
    var productCollisionObserver = null;
    var state = {
      variant: '',
      stage: 'email',
      signup: null,
      email: '',
      couponCode: '',
      reward: null,
      rewardClaimToken: '',
      rewardPromise: null,
      opening: false,
      profileClaimToken: '',
      profile: {},
      profileCompletion: '',
      selectedModel: null,
      history: [],
      turnstileToken: '',
      submitting: false,
      profileSubmitting: false,
      offerRevealed: false,
      scratchCompleted: false,
      testMode: false,
      destroyed: false,
      initialized: false
    };

    if (!overlay || !dialog || !teaser || !emailForm || !emailInput) throw new Error('NBB welcome popup markup is incomplete');

    function safeGet(key) {
      try { return storage.getItem(key); } catch (_error) { return null; }
    }

    function safeSet(key, value) {
      try { storage.setItem(key, String(value)); } catch (_error) {}
    }

    function dismissalCount(timestampKey, countKey) {
      var count = Math.floor(Number(safeGet(countKey)) || 0);
      if (count > 0) return count;
      // A legacy timestamp records one actual dismissal, not the maximum stage.
      return Number(safeGet(timestampKey)) > 0 ? 1 : 0;
    }

    function recordDismissal(timestampKey, countKey) {
      if (state.testMode || safeGet(keys.completed)) return;
      safeSet(countKey, dismissalCount(timestampKey, countKey) + 1);
      safeSet(timestampKey, now());
    }

    function fixedSurfaceClaimed() {
      var claimedAt = Number(safeGet(FIXED_SURFACE_SESSION_KEY) || 0);
      return claimedAt > 0 && now() - claimedAt < FIXED_SURFACE_SESSION_MS;
    }

    function claimFixedSurface() {
      safeSet(FIXED_SURFACE_SESSION_KEY, now());
    }

    function on(target, eventName, handler, options) {
      if (!target) return;
      target.addEventListener(eventName, handler, options);
      listeners.push(function () { target.removeEventListener(eventName, handler, options); });
    }

    function pageType() {
      var path = win.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
      if (/^\/products(?:\/|$)|^\/collections\/[^/]+\/products(?:\/|$)/i.test(path)) return 'product';
      if (/^\/collections(?:\/|$)/i.test(path)) return 'collection';
      return path === '/' ? 'home' : 'other';
    }

    function deviceType() {
      var agent = win.navigator.userAgent || '';
      if (/iPad|Tablet|Android(?!.*Mobile)/i.test(agent) || (/Macintosh/.test(agent) && win.navigator.maxTouchPoints > 1)) return 'tablet';
      return /Mobi|iPhone|iPod/i.test(agent) ? 'mobile' : 'desktop';
    }

    function coverage(stage) {
      if (state.testMode || coverageStages.has(stage) || !analytics || typeof analytics.publish !== 'function') return;
      coverageStages.add(stage);
      analytics.publish('popup_coverage', {
        popup_id: 'commercial_welcome', popup_version: experimentVersion,
        experiment_id: experimentVersion, popup_variant: state.variant || 'unassigned',
        page_type: pageType(), step_id: stage, locale: root.dataset.locale || 'en', device_type: deviceType()
      });
    }

    function competingInteraction() {
      if (doc.hidden) return true;
      var focused = doc.activeElement;
      if (focused && !root.contains(focused) && focused.matches('input, select, textarea, [contenteditable="true"]')) return true;
      return Array.prototype.some.call(doc.querySelectorAll('[aria-modal="true"], dialog[open], cart-drawer.active, .drawer.is-open, .drawer--is-open, #shopify-pc__banner, #shopify-privacy-banner'), function (element) {
        if (root.contains(element) || element.hidden || element.closest('[hidden], [aria-hidden="true"]')) return false;
        var style = win.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    function maybeAutoOpen() {
      if (!autoAllowed || !delayReady || !engaged || state.destroyed || !state.initialized || !overlay.hidden) return;
      if (!state.testMode && fixedSurfaceClaimed()) { autoAllowed = false; coverage('suppressed_session'); return; }
      if (competingInteraction()) return;
      open('auto');
    }

    function revealTeaser() {
      var shell = root.querySelector('[data-welcome-teaser-shell]');
      if (root.dataset.productArm === 'floating') {
        ['premium', 'scratch'].forEach(function (variant) {
          var label = root.querySelector('.nbb-wp__teaser-copy strong[data-' + variant + '-copy]');
          if (!label) return;
          label.textContent = variant === 'scratch' ? 'Scratch & win ' : 'Get 10% off ';
          var arrow = doc.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→'; label.appendChild(arrow);
        });
        teaser.setAttribute('aria-label', (state.variant === 'scratch' ? 'Scratch & win' : 'Get 10% off') + ' — open welcome offer');
      }
      if (pageType() === 'product' && shell && !root.dataset.productArm) {
        // Put the invitation after purchase controls, leaving the modal outside product stacking contexts.
        var form = Array.prototype.find.call(doc.querySelectorAll('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]'), function (candidate) { return !!candidate.querySelector('[type="submit"]'); });
        var anchor = form && (form.closest('product-form-context, product-form') || form);
        if (!anchor) anchor = doc.querySelector('main, #MainContent');
        if (anchor) {
          productTeaserHost = doc.createElement('div');
          productTeaserHost.className = 'nbb-wp nbb-wp--product-offer is-' + state.variant;
          anchor.insertAdjacentElement('afterend', productTeaserHost);
          productTeaserHost.appendChild(shell);
        }
      }
      quietProductTeaser();
      if (shell && win.IntersectionObserver) {
        teaserObserver = new win.IntersectionObserver(function (entries) {
          if (!shell.hidden && entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.5; })) {
            emit('teaser_viewed', 'teaser'); teaserObserver.disconnect();
          }
        }, { threshold: 0.5 });
        teaserObserver.observe(shell);
      } else emit('teaser_viewed', 'teaser');
    }

    function quietProductTeaser() {
      if (root.dataset.productArm !== 'floating') return;
      var shell = root.querySelector('[data-welcome-teaser-shell]');
      if (!shell || root.hidden) return;
      if (!state.testMode && productExperiment && !productExperiment.allowed()) { root.hidden = true; return; }
      shell.hidden = false;
      var rect = shell.getBoundingClientRect();
      var collision = competingInteraction() || Array.prototype.some.call(doc.querySelectorAll('form[action*="/cart/add"] [type="submit"], .shopify-payment-button'), function (button) {
        var r = button.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && rect.left < r.right + 12 && rect.right > r.left - 12 && rect.top < r.bottom + 12 && rect.bottom > r.top - 12;
      });
      shell.hidden = collision || !overlay.hidden || Boolean(!state.testMode && Number(safeGet(keys.teaserDismissed)) > 0 && now() - Number(safeGet(keys.teaserDismissed)) < core.dismissalCooldownMs(dismissalCount(keys.teaserDismissed, keys.teaserDismissCount)));
    }

    function analyticsInput(surface, errorCategory) {
      var input = {
        popupVersion: experimentVersion,
        popupVariant: state.variant,
        surface: surface || 'modal',
        pageType: root.dataset.pageType || 'unknown',
        locale: root.dataset.locale || 'en'
      };
      if (errorCategory) input.errorCategory = errorCategory;
      return input;
    }

    function emit(action, surface, errorCategory, logicalStep) {
      if (state.testMode) return;
      if (productExperiment && pageType() === 'product') {
        var placementEvent = { teaser_viewed: 'teaser_viewed', popup_opened: 'modal_opened', email_attempted: 'email_attempted', dismissed: 'dismissed' }[action];
        if (placementEvent) productExperiment.event(placementEvent);
      }
      var coverageMap = { eligible: 'eligible', teaser_viewed: 'teaser_viewed', popup_opened: 'modal_opened', signup_succeeded: 'signup_completed' };
      if (coverageMap[action]) coverage(coverageMap[action]);
      if (ONCE_ACTIONS.has(action) && emitted.has(action)) return;
      var detail;
      try { detail = core.analyticsDetail(action, analyticsInput(surface, errorCategory)); }
      catch (_error) { return; }
      if (ONCE_ACTIONS.has(action)) emitted.add(action);
      root.dispatchEvent(new win.CustomEvent('nbb:welcome-popup', { bubbles: true, detail: detail }));
      var eventName = ANALYTICS_EVENTS[action];
      if (!eventName || !analytics || typeof analytics.publish !== 'function') return;
      var payload = {
        popup_id: 'commercial_welcome',
        popup_version: detail.popup_version,
        popup_variant: detail.popup_variant,
        popup_surface: detail.surface || 'modal',
        experiment_id: 'welcome_popup_premium_vs_scratch',
        page_type: detail.page_type,
        locale: detail.locale
      };
      if (action === 'popup_opened') payload.popup_trigger = detail.surface === 'teaser' ? 'teaser' : 'auto';
      if (detail.error_category) payload.error_category = detail.error_category;
      if (eventName === 'popup_step_viewed') {
        payload.step_id = logicalStep || state.stage;
        payload.step_number = (state.variant === 'scratch' ? SCRATCH_STAGE_NUMBERS : PREMIUM_STAGE_NUMBERS)[payload.step_id] || 0;
      } else if (eventName === 'popup_profile_started' || eventName === 'popup_profile_step_completed' ||
          eventName === 'popup_profile_step_skipped' || eventName === 'popup_profile_completed') {
        payload.step_id = state.stage;
        payload.step_number = PROFILE_STEP_NUMBERS[state.stage] || 0;
      }
      analytics.publish(eventName, payload);
    }

    function emitStepViewed(logicalStep) {
      var step = logicalStep || state.stage;
      if (viewedStages.has(step)) return;
      viewedStages.add(step);
      emit('step_viewed', 'modal', '', step);
    }

    function startInteraction() {
      emit('interaction_started', 'modal');
    }

    function defaultReward() {
      return { id: 'percent_10', type: 'percentage', percent: 10, label: '10% off' };
    }

    function normalizeReward(value) {
      if (!value || typeof value !== 'object') return null;
      var percent = Number(value.percent || 0);
      if (value.type === 'percentage' && [10, 15, 20].indexOf(percent) !== -1) {
        return { id: 'percent_' + percent, type: 'percentage', percent: percent, label: percent + '% off' };
      }
      if (value.type === 'free_shipping') {
        return { id: 'free_shipping', type: 'free_shipping', percent: 0, label: 'free shipping' };
      }
      return null;
    }

    function rewardCta(reward) {
      return reward.type === 'free_shipping' ? 'Unlock free shipping' : 'Unlock my ' + reward.percent + '%';
    }

    function renderAssignedReward() {
      var reward = state.reward || defaultReward();
      root.classList.toggle('is-free-shipping', reward.type === 'free_shipping');
      var value = root.querySelector('[data-reward-value]');
      var unit = root.querySelector('[data-reward-unit]');
      var claimLabel = root.querySelector('[data-scratch-claim-label]');
      var rewardCopy = root.querySelector('[data-scratch-reward]');
      var storyReward = root.querySelector('[data-story-reward]');
      if (value) value.textContent = reward.type === 'free_shipping' ? 'FREE' : reward.percent + '%';
      if (unit) unit.textContent = reward.type === 'free_shipping' ? 'SHIPPING' : 'OFF';
      if (claimLabel) claimLabel.textContent = rewardCta(reward);
      if (rewardCopy) rewardCopy.innerHTML = 'Your <em>' + reward.label + '</em> code is ready.';
      if (storyReward && state.variant === 'scratch') storyReward.textContent = 'YOUR REWARD · ' + (reward.type === 'free_shipping' ? 'FREE SHIPPING' : reward.percent + '%');
    }

    function rewardEndpoint() {
      return String(root.dataset.rewardEndpoint || '').trim().replace(/\/welcome-signup\/?$/, '/welcome-reward');
    }

    function ensureScratchReward() {
      if (state.variant !== 'scratch') return Promise.resolve(defaultReward());
      if (state.reward) return Promise.resolve(state.reward);
      if (state.rewardPromise) return state.rewardPromise;
      var endpoint = rewardEndpoint();
      if (!endpoint) {
        state.reward = defaultReward();
        renderAssignedReward();
        return Promise.resolve(state.reward);
      }
      state.rewardPromise = fetcher(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ variant: 'scratch', experimentVersion: experimentVersion })
      }).then(function (response) {
        if (!response || !response.ok) throw new Error('reward_request_failed');
        return response.json();
      }).then(function (result) {
        var reward = normalizeReward(result && result.reward);
        var token = result && typeof result.rewardClaimToken === 'string' ? result.rewardClaimToken.trim() : '';
        if (!result || result.ok !== true || !reward || !token) throw new Error('reward_response_invalid');
        state.reward = reward;
        state.rewardClaimToken = token;
        renderAssignedReward();
        return reward;
      }).catch(function (error) {
        state.rewardPromise = null;
        emit('error', 'teaser', 'reward_assignment_failed');
        throw error;
      });
      return state.rewardPromise;
    }

    function focusableElements() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) { return !element.closest('[hidden]'); });
    }

    function showStage(stage, options) {
      if (STAGES.indexOf(stage) === -1) return;
      if (typeof options === 'boolean') options = { focus: options };
      options = options || {};
      if (state.stage !== stage && options.remember !== false) state.history.push(state.stage);
      state.stage = stage;
      Array.prototype.forEach.call(root.querySelectorAll('[data-stage]'), function (element) {
        element.hidden = element.dataset.stage !== stage;
      });
      var meta = STAGE_META[stage];
      var stageLabel = root.querySelector('[data-stage-label]');
      var progress = root.querySelector('[data-progress-fill]');
      if (stageLabel) stageLabel.textContent = meta.label;
      if (progress) progress.style.width = meta.progress;
      var back = root.querySelector('[data-profile-back]');
      if (back) back.hidden = BACK_STAGES.indexOf(stage) === -1 || !state.history.length;
      var current = root.querySelector('[data-stage="' + stage + '"]');
      var target = current && current.querySelector('input, button, [tabindex]');
      if (!overlay.hidden) emitStepViewed();
      if (options.focus !== false && !overlay.hidden && target) target.focus();
    }

    function goBack() {
      if (state.profileSubmitting || !state.history.length) return;
      var previousStage = state.history.pop();
      profileErrorPanel(false);
      showStage(previousStage, { remember: false });
      emit('profile_back_clicked', 'modal');
    }

    function ensureTurnstile() {
      if (dependencies.turnstileToken) {
        state.turnstileToken = dependencies.turnstileToken;
        return;
      }
      if (turnstileWidgetId !== null || !root.dataset.turnstileSiteKey || !win.turnstile || typeof win.turnstile.render !== 'function') return;
      var container = root.querySelector('[data-turnstile]');
      if (!container) return;
      turnstileWidgetId = win.turnstile.render(container, {
        sitekey: root.dataset.turnstileSiteKey,
        action: root.dataset.turnstileAction || 'welcome_popup_signup',
        theme: 'light',
        size: 'flexible',
        callback: function (token) { state.turnstileToken = token || ''; },
        'expired-callback': function () { state.turnstileToken = ''; },
        'error-callback': function () { state.turnstileToken = ''; },
        'timeout-callback': function () { state.turnstileToken = ''; }
      });
    }

    function resetTurnstile() {
      state.turnstileToken = dependencies.turnstileToken || '';
      if (turnstileWidgetId !== null && win.turnstile && typeof win.turnstile.reset === 'function') {
        try { win.turnstile.reset(turnstileWidgetId); } catch (_error) {}
      }
    }

    function open(trigger) {
      if (state.destroyed || !state.initialized || !overlay.hidden) return;
      if (state.variant === 'scratch' && !state.reward) {
        if (state.opening) return;
        state.opening = true;
        ensureScratchReward().then(function () {
          state.opening = false;
          open(trigger);
        }).catch(function () { state.opening = false; });
        return;
      }
      if (trigger === 'auto' && (pageType() === 'product' || !autoAllowed || competingInteraction())) return;
      if (trigger === 'auto' && !state.testMode && fixedSurfaceClaimed()) { autoAllowed = false; coverage('suppressed_session'); return; }
      autoAllowed = false;
      if (!state.testMode) claimFixedSurface();
      previousFocus = trigger && trigger.nodeType ? trigger : doc.activeElement;
      overlay.hidden = false;
      overlay.classList.add('is-opening');
      if (state.variant === 'scratch' && state.stage === 'scratch') prepareScratch();
      doc.body.classList.add('nbb-wp-scroll-locked');
      ensureTurnstile();
      dialog.focus();
      emit('popup_opened', trigger === teaser || trigger === 'teaser' ? 'teaser' : 'modal');
      quietProductTeaser();
      emitStepViewed();
      timers.push(setTimer(function () { overlay.classList.remove('is-opening'); }, 500));
    }

    function close(reason) {
      if (overlay.hidden) return;
      overlay.hidden = true;
      overlay.classList.remove('is-opening');
      quietProductTeaser();
      doc.body.classList.remove('nbb-wp-scroll-locked');
      recordDismissal(keys.dismissed, keys.modalDismissCount);
      emit('dismissed', 'modal');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      previousFocus = null;
    }

    function dismissTeaser() {
      if (state.destroyed || !state.initialized || !overlay.hidden) return;
      recordDismissal(keys.teaserDismissed, keys.teaserDismissCount);
      timers.splice(0).forEach(function (timer) { clearTimer(timer); });
      root.hidden = true;
      if (productTeaserHost) productTeaserHost.hidden = true;
      state.initialized = false;
      emit('dismissed', 'teaser');
    }

    function renderCoupon() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-coupon-code]'), function (element) {
        element.textContent = state.couponCode;
      });
    }

    function revealOffer(method) {
      if (state.offerRevealed || !state.couponCode) return;
      state.offerRevealed = true;
      var reward = root.querySelector('[data-reward]');
      var coupon = root.querySelector('[data-coupon]');
      var invitation = root.querySelector('[data-profile-invitation]');
      if (reward) reward.classList.add('is-code-visible');
      if (coupon) coupon.hidden = false;
      if (invitation) invitation.hidden = false;
      emit('offer_revealed', 'modal');
      var copy = root.querySelector('[data-copy-coupon]');
      if (copy && method === 'premium') copy.focus();
    }

    function prepareScratch() {
      if (scratchInstance) return;
      var scratchFactory = dependencies.scratch || win.NBBWelcomeScratch;
      if (scratchFactory && typeof scratchFactory.create === 'function') {
        scratchInstance = scratchFactory.create(root.querySelector('[data-scratch-canvas]'), {
          coin: root.querySelector('[data-scratch-coin]'),
          threshold: 0.5,
          reducedMotion: Boolean(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches),
          onStart: function () {
            startInteraction();
            emit('scratch_started', 'modal');
          },
          onComplete: function () { celebrateScratch('scratch'); }
        });
      }
    }

    function prepareReward() {
      renderCoupon();
      showStage('reward');
      revealOffer(state.variant === 'premium' ? 'premium' : 'signup');
    }

    function celebrateScratch(method) {
      if (state.scratchCompleted) return;
      state.scratchCompleted = true;
      var reward = root.querySelector('[data-reward]');
      if (reward) reward.classList.add('is-celebrating');
      var reduced = Boolean(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
      timers.push(setTimer(function () {
        var title = root.querySelector('[data-scratch-title]');
        var lede = root.querySelector('[data-scratch-lede]');
        var eyebrow = root.querySelector('[data-reward-eyebrow]');
        var claim = root.querySelector('[data-scratch-claim]');
        root.classList.add('is-claim-ready');
        if (eyebrow) eyebrow.textContent = 'REWARD REVEALED';
        var assignedReward = state.reward || defaultReward();
        if (title) title.innerHTML = 'You hit <em>' + assignedReward.label + '.</em>';
        if (lede) lede.textContent = 'It’s yours. Enter your email to unlock the code.';
        if (claim) claim.hidden = false;
        emitStepViewed('email_claim');
        if (!overlay.hidden) emailInput.focus();
      }, reduced ? 20 : 1750));
    }

    async function submitEmail(event) {
      event.preventDefault();
      if (state.submitting) return;
      startInteraction();
      var email = emailInput.value;
      if (!core.isValidEmail(email)) {
        emailError.textContent = 'Please enter a valid email address.';
        emailError.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        emit('error', 'modal', 'invalid_email');
        return;
      }
      if (!fetcher || !root.dataset.signupEndpoint) {
        emailError.textContent = 'This welcome gift is not connected yet. Please try again shortly.';
        emailError.hidden = false;
        emit('error', 'modal', 'missing_endpoint');
        return;
      }

      state.email = core.normalizeEmail(email);
      state.submitting = true;
      emailError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
      if (submitButton) submitButton.disabled = true;
      emit('email_attempted', 'modal');

      try {
        var payload = core.buildSignupPayload({ email: state.email, variant: state.variant }, {
          consent: true,
          locale: root.dataset.locale || 'en',
          sourceUrl: win.location.origin + win.location.pathname,
        deviceType: deviceType(),
          experimentVersion: experimentVersion,
          turnstileToken: state.turnstileToken || dependencies.turnstileToken || '',
          rewardClaimToken: state.rewardClaimToken
        });
        if (productExperiment && productExperiment.token()) payload.productExperimentToken = productExperiment.token();
        var response = await fetcher(root.dataset.signupEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response || !response.ok) throw new Error('signup_request_failed');
        var result = await response.json();
        var couponCode = result && typeof result.couponCode === 'string' ? result.couponCode.trim() : '';
        var claimToken = result && typeof result.profileClaimToken === 'string' ? result.profileClaimToken.trim() : '';
        var returnedReward = normalizeReward(result && result.reward) || (result && result.couponPercent === 10 ? defaultReward() : null);
        if (!result || result.ok !== true || !returnedReward || !couponCode || !claimToken ||
            (state.variant === 'scratch' && state.reward && returnedReward.id !== state.reward.id)) throw new Error('signup_response_invalid');
        state.signup = result;
        state.reward = returnedReward;
        state.couponCode = couponCode;
        state.profileClaimToken = claimToken;
        renderAssignedReward();
        safeSet(keys.completed, now());
        emit('signup_succeeded', 'modal');
        prepareReward();
      } catch (_error) {
        emailError.textContent = 'We couldn’t save your welcome gift just now. Please try once more.';
        emailError.hidden = false;
        resetTurnstile();
        emit('error', 'modal', 'signup_failed');
      } finally {
        state.submitting = false;
        if (submitButton) submitButton.disabled = false;
      }
    }

    async function copyCoupon(label, codeElement) {
      if (!state.couponCode) return;
      try {
        if (!clipboard || typeof clipboard.writeText !== 'function') throw new Error('clipboard_unavailable');
        await clipboard.writeText(state.couponCode);
        if (label) label.textContent = 'Copied!';
        emit('coupon_copied', 'modal');
      } catch (_error) {
        codeElement = codeElement || root.querySelector('[data-coupon-code]');
        if (codeElement && doc.createRange && win.getSelection) {
          var range = doc.createRange();
          range.selectNodeContents(codeElement);
          var selection = win.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        if (label) label.textContent = 'Press and hold to copy';
      }
    }

    function showDone() {
      showStage('done');
    }

    function profileErrorPanel(show) {
      var panel = root.querySelector('[data-profile-error-panel]');
      if (panel) panel.hidden = !show;
    }

    function profileAnswerButtons() {
      var stage = root.querySelector('[data-stage="' + state.stage + '"]');
      return stage ? Array.prototype.slice.call(stage.querySelectorAll(
        '[data-brand-choice], [data-model-choice], [data-model-unlisted], ' +
        '[data-size-choice], [data-size-not-sure], [data-usecase-choice], [data-material-choice]'
      )) : [];
    }

    function setProfileBusy(busy) {
      state.profileSubmitting = busy;
      if (busy) profileBusyButtons = profileAnswerButtons();
      profileBusyButtons.forEach(function (button) { button.disabled = busy; });
      if (!busy) profileBusyButtons = [];
    }

    function safeProfileResponse(result, expectedCompletion) {
      var allowed = ['brand', 'model', 'size', 'usecase', 'material'];
      return result && result.ok === true && result.completion === expectedCompletion &&
        Array.isArray(result.savedFields) && result.savedFields.every(function (field) { return allowed.indexOf(field) > -1; });
    }

    function renderModelOptions() {
      var container = root.querySelector('[data-model-results]');
      var search = root.querySelector('[data-model-search]');
      if (!container) return;
      container.textContent = '';
      profileCore.modelsForBrand(state.profile.brand, search ? search.value : '').forEach(function (model) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.dataset.modelChoice = model.name;
        button.textContent = model.name;
        container.appendChild(button);
      });
    }

    function renderSizeOptions(model) {
      var container = root.querySelector('[data-size-options]');
      if (!container) return;
      container.textContent = '';
      (model && Array.isArray(model.sizes) ? model.sizes : []).forEach(function (size) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.dataset.sizeChoice = size;
        button.textContent = size;
        container.appendChild(button);
      });
    }

    async function patchProfile(candidate, completion, nextStage, failedField) {
      if (state.profileSubmitting || !fetcher || !root.dataset.profileEndpoint) return false;
      var normalized;
      try {
        normalized = profileCore.normalizeAnswers(candidate);
        var payload = core.buildProfilePayload(state.profileClaimToken, normalized, completion);
        pendingProfileSave = {
          candidate: normalized,
          completion: completion,
          nextStage: nextStage,
          failedField: failedField || ''
        };
        setProfileBusy(true);
        profileErrorPanel(false);
        var response = await fetcher(root.dataset.profileEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response || !response.ok) throw new Error('profile_request_failed');
        var result = await response.json();
        if (!safeProfileResponse(result, completion)) throw new Error('profile_response_invalid');
        state.profile = normalized;
        state.profileCompletion = completion;
        pendingProfileSave = null;
        if (completion === 'started') emit('profile_started', 'modal');
        else if (completion === 'complete') emit('profile_completed', 'modal');
        else emit('profile_step_saved', 'modal');
        if (nextStage === 'model') renderModelOptions();
        if (nextStage === 'size') renderSizeOptions(state.selectedModel);
        if (nextStage === 'done') showDone();
        else showStage(nextStage);
        return true;
      } catch (_error) {
        emit('error', 'modal', 'profile_failed');
        profileErrorPanel(true);
        return false;
      } finally {
        setProfileBusy(false);
      }
    }

    function startProfile() {
      showStage('brand');
      patchProfile({}, 'started', 'brand', '');
    }

    function chooseBrand(value) {
      var candidate = Object.assign({}, state.profile, { brand: value });
      delete candidate.model;
      delete candidate.size;
      state.selectedModel = null;
      patchProfile(candidate, 'partial', 'model', 'brand');
    }

    function chooseModel(value) {
      var model = profileCore.modelsForBrand(state.profile.brand, '').find(function (item) { return item.name === value; });
      state.selectedModel = model || { name: value, sizes: [] };
      var candidate = Object.assign({}, state.profile, { model: value });
      delete candidate.size;
      var nextStage = 'usecase';
      if (model && model.sizes.length === 1) candidate.size = model.sizes[0];
      else if (model && model.sizes.length > 1) nextStage = 'size';
      patchProfile(candidate, 'partial', nextStage, 'model');
    }

    function chooseSize(value) {
      patchProfile(Object.assign({}, state.profile, { size: value }), 'partial', 'usecase', 'size');
    }

    function chooseUseCase(value) {
      patchProfile(Object.assign({}, state.profile, { usecase: value }), 'partial', 'material', 'usecase');
    }

    function chooseMaterial(value) {
      patchProfile(Object.assign({}, state.profile, { material: value }), 'complete', 'done', 'material');
    }

    function retryProfileSave() {
      if (!pendingProfileSave) return;
      var pending = pendingProfileSave;
      pendingProfileSave = null;
      patchProfile(pending.candidate, pending.completion, pending.nextStage, pending.failedField);
    }

    function continueWithoutProfileAnswer() {
      if (!pendingProfileSave) return;
      var pending = pendingProfileSave;
      pendingProfileSave = null;
      profileErrorPanel(false);
      emit('profile_step_skipped', 'modal');
      if (pending.completion === 'complete') patchProfile(state.profile, 'complete', 'done', '');
      else if (pending.nextStage === 'done') showDone();
      else showStage(pending.nextStage || state.stage);
    }

    async function initialize(identified) {
      if (state.destroyed || state.initialized || placementPending) return;
      var pathname = win.location.pathname;
      try { state.testMode = new URL(win.location.href).searchParams.get('welcome_popup_test') === '1'; }
      catch (_error) { state.testMode = false; }
      coverage('page_viewed');
      if ((root.dataset.scope === 'homepage' && pageType() !== 'home') || doc.getElementById('nbb-blog-guide') || !core.routeEligibility(pathname).eligible) {
        coverage('suppressed_route'); return;
      }
      root.dataset.dismissalSchedule = '1,3,7,30';
      var teaserCooldownMs = core.dismissalCooldownMs(dismissalCount(keys.teaserDismissed, keys.teaserDismissCount));
      var modalCooldownMs = core.dismissalCooldownMs(dismissalCount(keys.dismissed, keys.modalDismissCount));
      var teaserDismissedAt = Number(safeGet(keys.teaserDismissed) || 0);
      var completed = Boolean(safeGet(keys.completed));
      if (!state.testMode && completed) { coverage('suppressed_completed'); return; }
      if (!state.testMode && identified === true) { coverage('suppressed_identified'); return; }
      if (!state.testMode && teaserDismissedAt > 0 && now() - teaserDismissedAt < teaserCooldownMs) {
        coverage('suppressed_teaser_cooldown'); return;
      }
      var dismissedAt = Number(safeGet(keys.dismissed) || 0);
      var modalCooldown = !state.testMode && dismissedAt > 0 && now() - dismissedAt < modalCooldownMs;
      var sessionClaimed = !state.testMode && fixedSurfaceClaimed();
      var forced = root.dataset.forceVariant || '';
      if (state.testMode) { try { forced = new URL(win.location.href).searchParams.get('welcome_popup_variant') || forced; } catch (_error) {} }
      var stored = safeGet(keys.variant);
      state.variant = core.resolveVariant({ forcedVariant: forced, storedVariant: stored, randomValue: random(), allocation: Number(root.dataset.allocation) });
      if (!forced && !stored && !state.testMode) safeSet(keys.variant, state.variant);
      if (pageType() === 'product' && root.dataset.productExperiment === 'product_placement_v1') {
        placementPending = true;
        var assignment;
        try { assignment = productExperiment && await productExperiment.enroll(state.variant, deviceType(), root.dataset.locale || 'en'); }
        catch (_error) { assignment = null; }
        placementPending = false;
        if (state.destroyed) return;
        if (!assignment) { coverage('suppressed_experiment_unavailable'); return; }
        root.dataset.productArm = assignment.arm;
        state.variant = assignment.rewardVariant;
        if (!state.testMode) safeSet(keys.variant, state.variant);
        if (assignment.arm === 'control') { state.initialized = true; coverage('experiment_control'); return; }
      }
      root.classList.add(state.variant === 'scratch' ? 'is-scratch' : 'is-premium');
      root.dataset.placement = pageType();
      root.hidden = false;
      state.initialized = true;
      if (state.variant === 'scratch') {
        ensureScratchReward().catch(function () {});
        var claim = root.querySelector('[data-scratch-claim]');
        if (claim) claim.appendChild(emailForm);
        showStage('scratch', { focus: false, remember: false });
      } else showStage('email', { focus: false, remember: false });
      emit('eligible', 'teaser');
      revealTeaser();
      if (root.dataset.productArm === 'floating' && win.MutationObserver) {
        productCollisionObserver = new win.MutationObserver(quietProductTeaser);
        productCollisionObserver.observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
      }
      if (modalCooldown) coverage('suppressed_modal_cooldown');
      if (sessionClaimed) coverage('suppressed_session');
      autoAllowed = !modalCooldown && !sessionClaimed && (state.testMode || teaserDismissedAt <= 0) && (pageType() === 'home' || pageType() === 'collection');
      if (autoAllowed) {
        autoTimer = setTimer(function () { delayReady = true; maybeAutoOpen(); }, Math.max(12000, Number(root.dataset.delayMs) || 12000));
        timers.push(autoTimer);
      }
    }

    on(win, 'scroll', function () {
      var distance = doc.documentElement.scrollHeight - win.innerHeight;
      if (distance > 0 && win.scrollY / distance >= 0.25) engaged = true;
      maybeAutoOpen();
      quietProductTeaser();
    }, { passive: true });
    on(doc, 'focusout', function () { timers.push(setTimer(maybeAutoOpen, 1000)); });
    on(doc, 'visibilitychange', maybeAutoOpen);
    on(win, 'resize', quietProductTeaser);
    on(doc, 'visitorConsentCollected', quietProductTeaser);
    on(doc, 'nbb:product-experiment-ready', function () { initialize(dependencies.identified === true); });

    on(teaser, 'click', function () { open(teaser); });
    on(teaserDismiss, 'click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dismissTeaser();
    });
    on(root.querySelector('[data-close-popup]'), 'click', function () { close('button'); });
    on(emailForm, 'submit', submitEmail);
    on(emailInput, 'input', startInteraction);
    on(root.querySelector('[data-copy-coupon]'), 'click', function () {
      copyCoupon(root.querySelector('[data-copy-label]'), root.querySelector('[data-coupon] [data-coupon-code]'));
    });
    on(root.querySelector('[data-continue-profile]'), 'click', startProfile);
    on(root.querySelector('[data-profile-back]'), 'click', goBack);
    on(root.querySelector('[data-finish-reward]'), 'click', showDone);
    on(root.querySelector('[data-close-done]'), 'click', function () { close('done'); });
    on(root.querySelector('[data-scratch-fallback]'), 'click', function () {
      startInteraction();
      emit('scratch_started', 'modal');
      if (scratchInstance && typeof scratchInstance.reveal === 'function') scratchInstance.reveal();
      else celebrateScratch('button');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-brand-choice]'), function (button) {
      on(button, 'click', function () { chooseBrand(button.dataset.brandChoice); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-usecase-choice]'), function (button) {
      on(button, 'click', function () { chooseUseCase(button.dataset.usecaseChoice); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-material-choice]'), function (button) {
      on(button, 'click', function () { chooseMaterial(button.dataset.materialChoice); });
    });
    on(root.querySelector('[data-model-search]'), 'input', renderModelOptions);
    on(root.querySelector('[data-model-unlisted]'), 'click', function () { chooseModel('Unlisted model'); });
    on(root.querySelector('[data-size-not-sure]'), 'click', function () { chooseSize('not_sure'); });
    on(root.querySelector('[data-profile-retry]'), 'click', retryProfileSave);
    on(root.querySelector('[data-profile-continue]'), 'click', continueWithoutProfileAnswer);
    on(root.querySelector('[data-profile-finish-error]'), 'click', function () {
      pendingProfileSave = null;
      profileErrorPanel(false);
      showDone();
    });
    on(root, 'click', function (event) {
      var modelButton = event.target.closest && event.target.closest('[data-model-choice]');
      if (modelButton && root.contains(modelButton)) { chooseModel(modelButton.dataset.modelChoice); return; }
      var sizeButton = event.target.closest && event.target.closest('[data-size-choice]');
      if (sizeButton && root.contains(sizeButton)) chooseSize(sizeButton.dataset.sizeChoice);
    });
    on(overlay, 'click', function (event) { if (event.target === overlay) close('backdrop'); });
    on(doc, 'keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close('escape'); return; }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    var identified = dependencies.identified;
    if (typeof identified === 'boolean') initialize(identified);
    else if (win.klaviyo && typeof win.klaviyo.isIdentified === 'function') {
      try {
        Promise.resolve(win.klaviyo.isIdentified()).then(function (value) { initialize(value === true); }, function () { initialize(false); });
      } catch (_error) { initialize(false); }
    } else initialize(false);

    function destroy() {
      if (state.destroyed) return;
      state.destroyed = true;
      if (productExperiment) productExperiment.destroy();
      if (productCollisionObserver) productCollisionObserver.disconnect();
      if (teaserObserver) teaserObserver.disconnect();
      if (productTeaserHost) {
        var shell = productTeaserHost.querySelector('[data-welcome-teaser-shell]');
        if (shell) root.insertBefore(shell, root.firstChild);
        productTeaserHost.remove();
      }
      listeners.splice(0).forEach(function (remove) { remove(); });
      timers.splice(0).forEach(function (timer) { clearTimer(timer); });
      if (scratchInstance && typeof scratchInstance.destroy === 'function') scratchInstance.destroy();
      doc.body.classList.remove('nbb-wp-scroll-locked');
      if (activeInstance === instance) activeInstance = null;
    }

    var instance = {
      open: open,
      close: close,
      destroy: destroy,
      state: function () { return Object.assign({}, state, { profile: Object.assign({}, state.profile) }); }
    };
    activeInstance = instance;
    return instance;
  }

  function destroy() {
    if (activeInstance) activeInstance.destroy();
  }

  return { create: create, destroy: destroy };
});
